import React, { useEffect, useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { Collapse, ListItem, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material'
import List from '@mui/material/List'
import Icon from '@mui/material/Icon'
import { useGetMenuQuery } from '../../../store/api/menuApi'
import Weather from '../partial/Weather';

const Menu = () => {
    const { data } = useGetMenuQuery()
    const [url, setUrl] = useState(false)
    const location = useLocation()

    useEffect(() => {
        localStorage.setItem('getDataBool', url)
    }, [url])

    const [expandedIndex, setExpandedIndex] = useState(-1)
    const [active, setActive] = useState(0)

    const handleClick = (nextIndex) => {
        setActive(-1)
        expandedIndex === nextIndex ? setExpandedIndex(-1) : setExpandedIndex(nextIndex)
    }

    const handleActive = (index, e) => {
        setActive(prevActive => (prevActive === index ? -1 : index));
        localStorage.removeItem("reviseId")
        localStorage.removeItem("isRevise")
        localStorage.setItem("isAuthentication", true)
    }

    const checkParentIsActive = (item) => {
        return item?.childs?.map(x => x?.url).some(x => location.pathname.includes(x) || (location.pathname.includes('select-request') && x === '/rfqs'))
    }

    return (
        <div>
            {data?.data.map(
                (item, index) =>
                    item?.readAccess && (
                        <List key={item.id} component="nav">
                            {item?.url === null ? (
                                <>
                                    <Tooltip arrow title={item.parentMenuName} placement="right">
                                        <ListItem style={{
                                            backgroundColor: checkParentIsActive(item) && '#4695e3',
                                            color: checkParentIsActive(item) && '#fff'
                                        }} key={item.id} disablePadding>
                                            <ListItemButton onClick={() => handleClick(index)}>
                                                <ListItemIcon title={item.parentMenuName}>
                                                    <Icon style={{
                                                        color: checkParentIsActive(item) && '#fff'
                                                    }}>{item.reactIcon}</Icon>
                                                </ListItemIcon>

                                                <ListItemText primary={item.parentMenuName} />
                                                {expandedIndex === index ? <ExpandLess /> : <ExpandMore />}
                                            </ListItemButton>
                                        </ListItem>
                                    </Tooltip>

                                    {item?.childs?.filter(element => element?.url !== '/bids') 
                                        .map((element, i) => {
                                            if (element?.readAccess) {
                                                return (
                                                    <Collapse key={element.id} in={expandedIndex === index} timeout="auto"
                                                        unmountOnExit>
                                                        <List key={element.id} component="div" disablePadding>
                                                            <Tooltip arrow title={element.childMenuName} placement="right">
                                                                <NavLink
                                                                    onClick={() => setUrl(element.url === '/evaluation-form')}
                                                                    to={element.url}
                                                                    style={{
                                                                        color: 'inherit',
                                                                        textDecoration: 'inherit',
                                                                    }}
                                                                >
                                                                    {({ isActive }) => (
                                                                        <ListItem key={element.id}>
                                                                            <ListItemButton
                                                                                onClick={(e) => handleActive(i, e)}
                                                                                style={{
                                                                                    backgroundColor: (location.pathname.includes('select-request') && element.url === '/rfqs' || isActive) && '#4695e3',
                                                                                    color: (location.pathname.includes('select-request') && element.url === '/rfqs' || isActive) && 'white',
                                                                                    transition: '.4s',
                                                                                    borderRadius: '5px',
                                                                                }}
                                                                            >
                                                                                <ListItemIcon
                                                                                    title={element.childMenuName}
                                                                                    style={{
                                                                                        color: (location.pathname.includes('select-request') && element.url === '/rfqs' || isActive) && 'white',
                                                                                        transition: '.4s'
                                                                                    }}
                                                                                >
                                                                                    <Icon>{element.reactIcon}</Icon>
                                                                                </ListItemIcon>
                                                                                <ListItemText primary={element.childMenuName} />
                                                                            </ListItemButton>
                                                                        </ListItem>
                                                                    )}
                                                                </NavLink>
                                                            </Tooltip>
                                                        </List>
                                                    </Collapse>
                                                )
                                            }
                                        })}
                                </>
                            ) : (
                                <Link
                                    to={item.url}
                                    style={{
                                        color: 'inherit',
                                        textDecoration: 'inherit',
                                    }}
                                >
                                    <ListItem key={item.id} disablePadding>
                                        <ListItemButton>
                                            <ListItemIcon title={item.parentMenuName}>
                                                <Icon aria-label="Delete">{item.reactIcon}</Icon>
                                            </ListItemIcon>
                                            <ListItemText primary={item.parentMenuName} />
                                        </ListItemButton>
                                    </ListItem>
                                </Link>
                            )}
                        </List>
                    )
            )}

        </div>
    )
}

export default Menu
